export enum PositionFilterType {
  AllPositions = 'AllPositions',
  AllActivePositions = 'AllActivePositions',
  NotStarted = 'NotStarted',
  InProcess = 'InProcess',
  Complete = 'Complete',
  InactivePositions = 'InactivePositions'
}
